import React from 'react';
import { Play, Pause, RotateCcw } from 'lucide-react';

const TimerDisplay = ({ 
  minutes, 
  seconds, 
  isActive, 
  isBreak, 
  currentTask, 
  setCurrentTask, 
  onToggle, 
  onReset,
  theme 
}) => {
  return (
    <div className={`p-8 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg text-center`}>
      <div className="mb-6">
        <div className="text-6xl font-bold tabular-nums">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </div>
        <div className="text-lg text-gray-500 mt-2">
          {isBreak ? 'Break Time' : 'Focus Time'}
        </div>
      </div>

      {!isBreak && !isActive && (
        <div className="mb-6">
          <input
            type="text"
            value={currentTask}
            onChange={(e) => setCurrentTask(e.target.value)}
            placeholder="What are you working on?"
            className={`w-full max-w-sm px-4 py-2 rounded-lg border ${
              theme === 'dark' 
                ? 'bg-gray-700 border-gray-600' 
                : 'bg-gray-50 border-gray-300'
            } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
          />
        </div>
      )}

      <div className="flex justify-center space-x-4">
        <button
          onClick={onToggle}
          className={`px-6 py-3 rounded-lg font-medium flex items-center space-x-2 ${
            isActive 
              ? 'bg-red-600 text-white hover:bg-red-700' 
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          {isActive ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5" />}
          <span>{isActive ? 'Pause' : 'Start'}</span>
        </button>
        <button
          onClick={onReset}
          className="px-6 py-3 rounded-lg font-medium border border-gray-300 hover:bg-gray-50 flex items-center space-x-2"
        >
          <RotateCcw className="w-5 h-5" />
          <span>Reset</span>
        </button>
      </div>
    </div>
  );
};

export default TimerDisplay;